"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PureItem = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _intlUtils = require("@formatjs/intl-utils");

var _classnames = _interopRequireDefault(require("classnames"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _reactTransitionGroup = require("react-transition-group");

var _scrollIntoViewIfNeeded = _interopRequireDefault(require("scroll-into-view-if-needed"));

var _reactLinkify = _interopRequireDefault(require("react-linkify"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button"));

var _Link = _interopRequireDefault(require("@react/react-spectrum/Link"));

var _OverlayTrigger = _interopRequireDefault(require("@react/react-spectrum/OverlayTrigger"));

var _Send = _interopRequireDefault(require("@react/react-spectrum/Icon/Send"));

var _ChevronRight = _interopRequireDefault(require("@react/react-spectrum/Icon/ChevronRight"));

var _CommentDropdownMenu = _interopRequireDefault(require("./CommentDropdownMenu/CommentDropdownMenu"));

var _Divider = _interopRequireDefault(require("../Divider/Divider"));

var _CommentInput = _interopRequireDefault(require("../CommentInput/CommentInput"));

var _UserAvatar = _interopRequireDefault(require("../UserAvatar"));

var _UserCard = _interopRequireWildcard(require("../UserCard"));

var _Login = _interopRequireDefault(require("../Login/Login"));

var _ItemFooterActions = _interopRequireDefault(require("./ItemFooterActions"));

var _AnnotationMarker = _interopRequireDefault(require("./AnnotationMarker"));

var _annotation = require("../../actions/annotation");

var _CallbackContext = _interopRequireDefault(require("../../context/CallbackContext"));

var _context = require("../../actions/context");

var _comments = require("../../actions/comments");

var _utils = require("../../lib/utils");

var _AppContext = require("../../context/AppContext");

var _constants = require("../../constants");

var _Item = _interopRequireDefault(require("./Item.scss"));

var _reducers = require("../../reducers");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var HIGHLIGHT_DURATION = 6000;
var SCROLL_DURATION = 150;
var REPLY_INPUT_OFFSET_TOP = 32;
var DATE_FORMAT_OPTION = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric'
};
/**
 * Item component.
 */

var Item = /*#__PURE__*/function (_React$Component) {
  _inherits(Item, _React$Component);

  var _super = _createSuper(Item);

  /**
   * Constructor for the Item component
   * @param {object} props - props sent to the component
   * @returns {undefined}
   */
  function Item(props) {
    var _this;

    _classCallCheck(this, Item);

    _this = _super.call(this, props);
    var dirtyEdit = (0, _lodash.default)(props, 'commentData.dirtyEdit');
    var bodyValue = (0, _lodash.default)(props, 'commentData.bodyValue');
    _this.state = {
      dirtyReply: '',
      isEditing: !!dirtyEdit,
      overEditTextLimit: false,
      overReplyTextLimit: false,
      showLogin: false,
      replyTextPresent: false,
      editTextPresent: !!bodyValue
    };
    _this.isAnnotated = _this.isAnnotated.bind(_assertThisInitialized(_this));
    _this.isInputFocused = _this.isInputFocused.bind(_assertThisInitialized(_this));
    _this.handleDeleteButtonClick = _this.handleDeleteButtonClick.bind(_assertThisInitialized(_this));
    _this.handleEditBtnClick = _this.handleEditBtnClick.bind(_assertThisInitialized(_this));
    _this.handleReplyButtonClick = _this.handleReplyButtonClick.bind(_assertThisInitialized(_this));
    _this.handleReplyBtnOnMouseDown = _this.handleReplyBtnOnMouseDown.bind(_assertThisInitialized(_this));
    _this.handleResolveButtonClick = _this.handleResolveButtonClick.bind(_assertThisInitialized(_this));
    _this.handleOpenButtonClick = _this.handleOpenButtonClick.bind(_assertThisInitialized(_this));
    _this.handleCommentItemRef = _this.handleCommentItemRef.bind(_assertThisInitialized(_this));
    _this.handleReplyTextareaRef = _this.handleReplyTextareaRef.bind(_assertThisInitialized(_this));
    _this.handleReplyOnKeyUp = _this.handleReplyOnKeyUp.bind(_assertThisInitialized(_this));
    _this.handleReplyOnClick = _this.handleReplyOnClick.bind(_assertThisInitialized(_this));
    _this.handleReplyOnBlur = _this.handleReplyOnBlur.bind(_assertThisInitialized(_this));
    _this.handleCancelEditBtnClick = _this.handleCancelEditBtnClick.bind(_assertThisInitialized(_this));
    _this.handleCancelReply = _this.handleCancelReply.bind(_assertThisInitialized(_this));
    _this.handleSaveEditChangesBtnClick = _this.handleSaveEditChangesBtnClick.bind(_assertThisInitialized(_this));
    _this.handleEditOnKeyUp = _this.handleEditOnKeyUp.bind(_assertThisInitialized(_this));
    _this.handleEditTextareaRef = _this.handleEditTextareaRef.bind(_assertThisInitialized(_this));
    _this.handleEditOnClick = _this.handleEditOnClick.bind(_assertThisInitialized(_this));
    _this.handleEditTextPresent = _this.handleEditTextPresent.bind(_assertThisInitialized(_this));
    _this.handleReplyTextPresent = _this.handleReplyTextPresent.bind(_assertThisInitialized(_this));
    _this.handlePinClick = _this.handlePinClick.bind(_assertThisInitialized(_this));
    _this.handleItemHover = _this.handleItemHover.bind(_assertThisInitialized(_this));
    _this.handleItemClick = _this.handleItemClick.bind(_assertThisInitialized(_this));
    _this.handleSubmitReply = _this.handleSubmitReply.bind(_assertThisInitialized(_this));
    _this.handleFocus = _this.handleFocus.bind(_assertThisInitialized(_this));
    _this.handleReplyFocus = _this.handleReplyFocus.bind(_assertThisInitialized(_this));
    _this.handleGuestLogin = _this.handleGuestLogin.bind(_assertThisInitialized(_this));
    _this.handleCancelLogin = _this.handleCancelLogin.bind(_assertThisInitialized(_this));
    _this.handleEditMentionClick = _this.handleEditMentionClick.bind(_assertThisInitialized(_this));
    _this.handleReplyMentionClick = _this.handleReplyMentionClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Lifecycle method for when a component is added to the DOM
   * @returns {undefined}
   */


  _createClass(Item, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          commentData = _this$props.commentData,
          setShowCommentId = _this$props.setShowCommentId,
          showCommentId = _this$props.showCommentId,
          touchControls = _this$props.touchControls;
      var id = commentData.id;

      if (showCommentId && showCommentId === id) {
        (0, _scrollIntoViewIfNeeded.default)(this._element, {
          block: touchControls ? 'center' : 'nearest',
          duration: SCROLL_DURATION
        });
        setTimeout(function () {
          setShowCommentId();
        }, HIGHLIGHT_DURATION);
      }
    }
    /**
     * Lifecycle method for when a component is about to be removed from the DOM
     * @returns {undefined}
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props2 = this.props,
          parentCommentId = _this$props2.parentCommentId,
          setHoveredAnnotation = _this$props2.setHoveredAnnotation,
          highlight = _this$props2.highlight;

      if (highlight && setHoveredAnnotation && !parentCommentId) {
        setHoveredAnnotation(undefined);
      }
    }
    /**
     * Lifecycle method for when a component is updated
     * @param {element} prevProps - previous props for component
     * @param {element} prevState - previous state for component
     * @returns {undefined}
     */

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _this$props3 = this.props,
          assetData = _this$props3.assetData,
          closeButtonClicked = _this$props3.closeButtonClicked,
          commentData = _this$props3.commentData,
          compactLayout = _this$props3.compactLayout,
          focusedInputInfo = _this$props3.focusedInputInfo,
          isSaving = _this$props3.isSaving,
          isSubmittingReply = _this$props3.isSubmittingReply,
          onScrollToComment = _this$props3.onScrollToComment,
          scrollIntoView = _this$props3.scrollIntoView,
          setClickedAnnotationCommentId = _this$props3.setClickedAnnotationCommentId,
          setShowCommentId = _this$props3.setShowCommentId,
          showCommentId = _this$props3.showCommentId,
          touchControls = _this$props3.touchControls;
      var isEditing = this.state.isEditing;
      var id = commentData.id,
          bodyValue = commentData.bodyValue,
          repliesOpen = commentData.repliesOpen,
          replies = commentData.replies;
      var prevRepliesOpen = !!(0, _lodash.default)(prevProps, 'commentData.repliesOpen');
      var switchingNodes = prevProps.assetData.nodeId !== assetData.nodeId;
      var noReplies = replies && replies.length === 0;

      if (!prevProps.scrollIntoView && scrollIntoView) {
        onScrollToComment(id);
        setClickedAnnotationCommentId('');
      }

      if (prevProps.isSaving && !isSaving) {
        var editSaved = bodyValue !== prevProps.commentData.bodyValue;

        if (editSaved) {
          this.setState({
            isEditing: false,
            editTextPresent: false
          });
        }

        if (compactLayout) {
          requestAnimationFrame(function () {
            (0, _scrollIntoViewIfNeeded.default)(_this2._element, {
              block: 'center'
            });
          });
        }
      }

      if (prevProps.isSubmittingReply && !isSubmittingReply) {
        (0, _utils.deleteFromSessionStorage)(_constants.REPLY_BEFORE_SIGNIN);
        this._replyTextareaEl && this._replyTextareaEl.clearTextareaInput();
        var replySubmitted = replies.length > prevProps.commentData.replies.length;

        if (replySubmitted) {
          this.setState({
            dirtyReply: ''
          });
        }

        if (compactLayout) {
          requestAnimationFrame(function () {
            (0, _scrollIntoViewIfNeeded.default)(_this2._element, {
              block: 'center'
            });
          });
        }
      }

      var replyTextarea = this._replyTextareaEl && this._replyTextareaEl.getComponentRef();

      if (!compactLayout && !switchingNodes && !prevRepliesOpen && noReplies && repliesOpen && this._replyTextareaEl && replyTextarea) {
        (0, _scrollIntoViewIfNeeded.default)(replyTextarea.parentElement, {
          block: touchControls ? 'center' : 'nearest',
          duration: SCROLL_DURATION
        });

        this._replyTextareaEl.setFocus();
      } // For comments with no replies, bring reply text
      // input into view if needed
      // https://jira.corp.adobe.com/browse/CCX-5886


      if (compactLayout && noReplies && !prevRepliesOpen && repliesOpen && this._replyTextareaEl && replyTextarea) {
        (0, _scrollIntoViewIfNeeded.default)(replyTextarea.parentElement, {
          block: 'end',
          scrollMode: 'if-needed',
          duration: SCROLL_DURATION
        });
      }

      var editTextarea = this._editTextareaEl && this._editTextareaEl.getComponentRef();

      if (!switchingNodes && prevProps && !prevState.isEditing && isEditing && this._editTextareaEl && editTextarea) {
        (0, _scrollIntoViewIfNeeded.default)(editTextarea, {
          block: touchControls ? 'center' : 'nearest',
          duration: SCROLL_DURATION
        });

        this._editTextareaEl.setFocus();
      }

      if (!prevProps.showCommentId && showCommentId && showCommentId === id) {
        requestAnimationFrame(function () {
          (0, _scrollIntoViewIfNeeded.default)(_this2._element, {
            block: touchControls ? 'center' : 'nearest',
            duration: SCROLL_DURATION
          });
          setTimeout(function () {
            setShowCommentId();
          }, HIGHLIGHT_DURATION);
        });
      }

      if (compactLayout && closeButtonClicked !== prevProps.closeButtonClicked && focusedInputInfo && focusedInputInfo[assetData.nodeId]) {
        if (focusedInputInfo[assetData.nodeId].id === id && this.state.isEditing) {
          this.handleCancelEditBtnClick();
        } else if (focusedInputInfo[assetData.nodeId].itemType === 'reply-input' && focusedInputInfo[assetData.nodeId].id === id) {
          this.cleanCurrentNodeFocusedInputInfo();

          this._toggleReply();
        }

        requestAnimationFrame(function () {
          (0, _scrollIntoViewIfNeeded.default)(_this2._element, {
            block: 'center'
          });
        });
      }
    }
    /**
     * Returns whether this comment has an annotation or not.
     * @return {boolean} true if a comment has an annotation; false, otherwise
     */

  }, {
    key: "isAnnotated",
    value: function isAnnotated() {
      var _this$props$commentDa = this.props.commentData,
          pinNum = _this$props$commentDa.pinNum,
          hasShapeAnnotation = _this$props$commentDa.hasShapeAnnotation,
          hasHighlightAnnotation = _this$props$commentDa.hasHighlightAnnotation,
          hasInsertAnnotation = _this$props$commentDa.hasInsertAnnotation,
          hasReplaceAnnotation = _this$props$commentDa.hasReplaceAnnotation,
          hasStrikethroughAnnotation = _this$props$commentDa.hasStrikethroughAnnotation;
      return Boolean(pinNum || pinNum === 0 || hasShapeAnnotation || hasHighlightAnnotation || hasInsertAnnotation || hasReplaceAnnotation || hasStrikethroughAnnotation);
    }
    /**
     * Returns whether the text input has focus or not.
     * @return {boolean} true or false
     */

  }, {
    key: "isInputFocused",
    value: function isInputFocused() {
      var _this$props4 = this.props,
          assetData = _this$props4.assetData,
          commentData = _this$props4.commentData,
          focusedInputInfo = _this$props4.focusedInputInfo;
      var commentInputFocused = false;

      switch (focusedInputInfo && focusedInputInfo[assetData.nodeId] && focusedInputInfo[assetData.nodeId].itemType) {
        case 'edit':
          commentInputFocused = focusedInputInfo[assetData.nodeId].id === commentData.id;
          break;

        case 'reply-input':
          commentInputFocused = focusedInputInfo[assetData.nodeId].id === commentData.id;
          break;

        case 'reply-item':
          commentInputFocused = focusedInputInfo[assetData.nodeId].parentCommentId === commentData.id;
          break;

        default:
          break;
      }

      return commentInputFocused;
    }
    /**
     * Handler for clicking the delete button.
     * @returns {undefined}
     */

  }, {
    key: "handleDeleteButtonClick",
    value: function handleDeleteButtonClick() {
      var _this$props5 = this.props,
          ccxIngest = _this$props5.ccxIngest,
          commentData = _this$props5.commentData,
          confirmDelete = _this$props5.confirmDelete,
          parentCommentId = _this$props5.parentCommentId;
      ccxIngest.fireEvent({
        event: {
          context_guid: parentCommentId,
          subcategory: parentCommentId ? 'delete-reply' : 'delete-comment',
          subtype: 'delete',
          type: 'click'
        }
      });
      confirmDelete(commentData.id, parentCommentId);
    }
    /**
     * Handler for clicking the reply button.
     * @returns {undefined}
     */

  }, {
    key: "handleReplyButtonClick",
    value: function handleReplyButtonClick() {
      var _this$props6 = this.props,
          ccxIngest = _this$props6.ccxIngest,
          commentData = _this$props6.commentData,
          toggleReplyVisibility = _this$props6.toggleReplyVisibility; // INGEST [REPLY COMMENT]: User clicks the reply button

      ccxIngest.fireEvent({
        event: {
          context_guid: commentData.id,
          subcategory: 'reply-comment',
          subtype: 'reply',
          type: 'click'
        }
      }, true);
      toggleReplyVisibility(commentData.id);
    }
    /**
     * Handler for mouseUp on the reply button
     * @param {Event} evt - javascript event object
     * @returns {undefined}
     */

  }, {
    key: "handleReplyBtnOnMouseDown",
    value: function handleReplyBtnOnMouseDown(evt) {
      evt && evt.preventDefault(); // TODO: Is this necessary? Why not just call `handleReplyButtonClick`?

      this.isClickingReply = true;
    }
    /**
     * Handles unresolve button click.
     * @param {SyntheticEvent} event - javascript event object
     * @return {undefined}
     */

  }, {
    key: "handleOpenButtonClick",
    value: function handleOpenButtonClick(event) {
      if (!(0, _utils.actionableKeyPress)(event)) {
        return;
      }

      var _this$props7 = this.props,
          assetData = _this$props7.assetData,
          cacheComments = _this$props7.cacheComments,
          ccxIngest = _this$props7.ccxIngest,
          commentData = _this$props7.commentData,
          imsData = _this$props7.imsData,
          resetGuestUserSession = _this$props7.resetGuestUserSession,
          unresolveComment = _this$props7.unresolveComment;
      var onLogin = this.context.onLogin;
      ccxIngest.fireEvent({
        event: {
          subcategory: 'resolve',
          subtype: 'move-to-unresolved',
          type: 'click'
        }
      });
      unresolveComment(assetData.id, commentData, cacheComments).then(function () {
        return ccxIngest.fireEvent({
          event: {
            subcategory: 'resolve',
            subtype: 'move-to-unresolved',
            type: 'render'
          }
        });
      }).catch(function (_ref) {
        var status = _ref.status,
            message = _ref.message;
        ccxIngest.fireEvent({
          event: {
            subcategory: 'resolve',
            subtype: 'error',
            type: 'render',
            error_code: status,
            error_type: message,
            error_desc: 'comment-failed-to-unresolve'
          }
        });

        if (imsData.token.includes('AnonBearer') && status === 401) {
          resetGuestUserSession();
          onLogin(false);
        }
      });
    }
    /**
     * Handler for clicking the resolve button.
     * @param {SyntheticEvent} event - event object
     * @returns {undefined}
     */

  }, {
    key: "handleResolveButtonClick",
    value: function handleResolveButtonClick(event) {
      if (!(0, _utils.actionableKeyPress)(event)) {
        return;
      }

      var _this$props8 = this.props,
          assetData = _this$props8.assetData,
          cacheComments = _this$props8.cacheComments,
          ccxIngest = _this$props8.ccxIngest,
          commentData = _this$props8.commentData,
          imsData = _this$props8.imsData,
          resetGuestUserSession = _this$props8.resetGuestUserSession,
          resolveComment = _this$props8.resolveComment,
          toggleReplyVisibility = _this$props8.toggleReplyVisibility;
      var id = commentData.id,
          replies = commentData.replies,
          repliesOpen = commentData.repliesOpen;
      var onLogin = this.context.onLogin;

      if (repliesOpen) {
        toggleReplyVisibility(id);
        replies.forEach(function (reply) {
          reply.dirtyEdit = null;
        });
      }

      ccxIngest.fireEvent({
        event: {
          subcategory: 'resolve',
          subtype: 'submit',
          type: 'click'
        }
      });
      resolveComment(assetData.id, commentData, cacheComments).then(function () {
        return ccxIngest.fireEvent({
          event: {
            subcategory: 'resolve',
            subtype: 'resolved-flag',
            type: 'render'
          }
        });
      }).catch(function (_ref2) {
        var status = _ref2.status,
            message = _ref2.message;
        ccxIngest.fireEvent({
          event: {
            subcategory: 'resolve',
            subtype: 'error',
            type: 'render',
            error_code: status,
            error_type: message,
            error_desc: 'comment-failed-to-resolve'
          }
        });

        if (imsData.token.includes('AnonBearer') && status === 401) {
          resetGuestUserSession();
          onLogin(false);
        }
      });
    }
    /**
     * Handler for attaching a ref
     * @param {element} ref - React element instance
     * @returns {undefined}
     */

  }, {
    key: "handleCommentItemRef",
    value: function handleCommentItemRef(ref) {
      this._element = ref;
    }
    /**
     * Function to render the header of a comment
     * @param {boolean} showActive - indication if item should be shown as active
     * @returns {ReactElement} element for the header
     */

  }, {
    key: "_getHeader",
    value: function _getHeader(showActive) {
      var _this$props9 = this.props,
          assetData = _this$props9.assetData,
          capabilities = _this$props9.capabilities,
          compactLayout = _this$props9.compactLayout,
          commentData = _this$props9.commentData,
          focusedInputInfo = _this$props9.focusedInputInfo,
          imsData = _this$props9.imsData,
          isOffline = _this$props9.isOffline,
          isResolved = _this$props9.isResolved,
          parentCommentId = _this$props9.parentCommentId;
      var isEditing = this.state.isEditing;

      if (compactLayout && focusedInputInfo && focusedInputInfo[assetData.nodeId] && focusedInputInfo[assetData.nodeId].itemType) {
        return null;
      }

      var ownershipTag;

      if (commentData.creator.id === assetData.ownerId) {
        ownershipTag = /*#__PURE__*/_react.default.createElement("span", {
          className: "owner-tag",
          "data-testid": "owner"
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "comments.item.owner"
        }));
      } else if (commentData.creator.affiliation === 'https://comments.acrobat.com/auth_providers/guest') {
        ownershipTag = /*#__PURE__*/_react.default.createElement("span", {
          className: "owner-tag",
          "data-testid": "guest"
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "comments.item.guest"
        }));
      }

      var isEditedComment;

      if (commentData && commentData.created && commentData.modified) {
        isEditedComment = commentData.created !== commentData.modified;
      }

      var safeDate = this._getSafeDate(commentData.modified);

      var _selectUnit = (0, _intlUtils.selectUnit)(safeDate),
          value = _selectUnit.value,
          unit = _selectUnit.unit;

      var commentDate = new Date(safeDate);
      var commentYear = commentDate.getFullYear();
      var currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0); // set to last midnight of current timezone

      var showMonthYear = false;

      if (commentDate.getTime() < currentDate.getTime()) {
        // if comment modified time is less than current date at midnight (local time), show "Month day"
        showMonthYear = true;
      }

      var showYear = false;
      var currentYear = currentDate.getFullYear();

      if (commentYear !== currentYear) {
        // if comment modified/created year does not equal to current year, show "Month day, year"
        showYear = true;
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: "header-row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "user-wrap"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "user-name"
      }, /*#__PURE__*/_react.default.createElement("span", {
        className: "comment-creator-name"
      }, commentData.creator.name), ownershipTag), /*#__PURE__*/_react.default.createElement("div", {
        className: "timestamp"
      }, showMonthYear ? '' : /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedRelativeTime, {
        value: value,
        unit: unit,
        updateIntervalInSeconds: 10
      }), showMonthYear && !showYear ? /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
        day: "2-digit",
        month: "short",
        value: safeDate
      }) : '', showMonthYear && showYear ? /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedDate, {
        day: "2-digit",
        month: "short",
        value: safeDate,
        year: "numeric"
      }) : '', isEditedComment ? /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
        id: "comments.item.edited_notify"
      }) : '')), /*#__PURE__*/_react.default.createElement(_CommentDropdownMenu.default, {
        assetData: assetData,
        userRole: capabilities.role,
        compactLayout: compactLayout,
        creator: commentData.creator,
        handleDeleteBtnClick: this.handleDeleteButtonClick,
        handleEditBtnClick: this.handleEditBtnClick,
        handleOpenBtnClick: this.handleOpenButtonClick,
        handleResolveBtnClick: this.handleResolveButtonClick,
        imsData: imsData,
        isEditing: isEditing,
        isOffline: isOffline,
        isReply: !!parentCommentId,
        isResolved: commentData.status === 'resolved' || isResolved,
        showActive: showActive
      }));
    }
    /**
     * Function to render the footer reply wrapper
     * @param {boolean} showActive - indication if item should be shown as active
     * @returns {ReactElement} element for the reply wrapper
     */

  }, {
    key: "_getFooterReplyWrapper",
    value: function _getFooterReplyWrapper(showActive) {
      var commentData = this.props.commentData;
      var hasReplies = commentData.replies && commentData.replies.length >= 1;
      var repliesOpen = commentData && !!commentData.repliesOpen;
      var buttonText;
      var buttonIcon = null;

      if (hasReplies) {
        buttonText = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "comments.item.replies",
          values: {
            noOfReplies: commentData.replies.length
          }
        });
        buttonIcon = /*#__PURE__*/_react.default.createElement(_ChevronRight.default, null);
      } else {
        buttonText = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "comments.item.reply"
        });
      }

      if ((commentData.status !== 'resolved' || hasReplies) && showActive) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('reply-btn-wrapper', {
            'replies-open': repliesOpen,
            'has-replies': hasReplies
          })
        }, /*#__PURE__*/_react.default.createElement(_Button.default, {
          "aria-expanded": repliesOpen,
          className: "reply-btn",
          onClick: this.handleReplyButtonClick,
          onMouseDown: this.handleReplyBtnOnMouseDown,
          quiet: true,
          variant: "secondary"
        }, buttonIcon, buttonText));
      }

      if (!showActive && hasReplies) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "reply-btn-wrapper"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "reply-caption"
        }, buttonText));
      }
    }
    /**
     * Function to render the footer
     * @param {boolean} showActive - indication if item should be shown as active
     * @returns {ReactElement} element for the footer
     */

  }, {
    key: "_getFooter",
    value: function _getFooter(showActive) {
      var _this$props10 = this.props,
          annotationTypes = _this$props10.annotationTypes,
          annotationsEnabled = _this$props10.annotationsEnabled,
          compactLayout = _this$props10.compactLayout,
          commentData = _this$props10.commentData,
          imsData = _this$props10.imsData,
          intl = _this$props10.intl,
          isAnnotating = _this$props10.isAnnotating,
          isOffline = _this$props10.isOffline,
          parentCommentId = _this$props10.parentCommentId,
          touchControls = _this$props10.touchControls;

      if (parentCommentId) {
        return null;
      }

      var creator = commentData.creator,
          pinNum = commentData.pinNum,
          unmapped = commentData.unmapped;
      var commentSubtype = (0, _lodash.default)(commentData, 'target.selector.subtype');
      var isCommentOwner = imsData.id !== undefined && imsData.id === creator.id;
      var isChildComment = !!parentCommentId;
      var isPinnable = Boolean(!annotationTypes && annotationsEnabled && isCommentOwner && !isChildComment && !unmapped && commentData.status !== 'resolved' && showActive && (commentSubtype === 'note' || commentSubtype === 'node') && ( // only show pin on compactLayout if no pin is placed, always show on desktop.
      !compactLayout || !pinNum));
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "footer"
      }, this._getFooterReplyWrapper(showActive), /*#__PURE__*/_react.default.createElement(_ItemFooterActions.default, {
        touchControls: touchControls,
        handlePinClick: this.handlePinClick,
        isPinnable: isPinnable,
        isAnnotating: isAnnotating,
        intl: intl,
        isVisible: !isOffline
      }));
    }
    /**
     * Create reference to the textarea input
     * @param {ReactElement} ref - react element to create a reference to
     * @return {undefined}
     */

  }, {
    key: "handleReplyTextareaRef",
    value: function handleReplyTextareaRef(ref) {
      this._replyTextareaEl = ref;
    }
    /**
     * Handle enter key submit comment if passes conditions
     * @param {Event} evt - javascript event object
     * @return {undefined}
     */

  }, {
    key: "handleReplyOnKeyUp",
    value: function handleReplyOnKeyUp(evt) {
      var _this$props11 = this.props,
          isOffline = _this$props11.isOffline,
          isSubmittingReply = _this$props11.isSubmittingReply;
      var _this$state = this.state,
          dirtyReply = _this$state.dirtyReply,
          overReplyTextLimit = _this$state.overReplyTextLimit;

      if ((0, _utils.isKeyboardSubmit)(evt) && dirtyReply && !overReplyTextLimit && !isSubmittingReply && !isOffline) {
        this.handleSubmitReply(evt, true);
      }
    }
    /**
     * Handle submit comment if passes conditions
     * @param {Event} evt - javascript event object
     * @param {Boolean} isPressedEnter - boolean to know if enter key is pressed or not
     * @return {undefined}
     */
    // eslint-disable-next-line

  }, {
    key: "handleSubmitReply",
    value: function handleSubmitReply(evt, isPressedEnter) {
      var _this3 = this;

      var _this$props12 = this.props,
          assetData = _this$props12.assetData,
          cacheComments = _this$props12.cacheComments,
          ccxIngest = _this$props12.ccxIngest,
          commentData = _this$props12.commentData,
          compactLayout = _this$props12.compactLayout,
          imsData = _this$props12.imsData,
          isSubmittingReply = _this$props12.isSubmittingReply,
          mentionsEnabled = _this$props12.mentionsEnabled,
          postReply = _this$props12.postReply,
          resetGuestUserSession = _this$props12.resetGuestUserSession;
      var onLogin = this.context.onLogin;
      var id = commentData.id;
      var textareaInstance = this._replyTextareaEl;
      var replyText = textareaInstance && textareaInstance.getTextareaInputValue(true);

      if (!imsData || !imsData.token) {
        // Store reply to session storage in case SUSI login is fired
        if (replyText) {
          (0, _utils.saveToSessionStorage)(_constants.REPLY_BEFORE_SIGNIN, {
            bodyValue: replyText,
            id: assetData.id,
            nodeId: assetData.nodeId,
            commentData: commentData
          });
        }

        this.setState({
          showLogin: true
        });
        return;
      } // Make sure login is no longer displayed


      this.setState({
        showLogin: false
      });

      if (!textareaInstance) {
        return;
      }

      if (replyText && !isSubmittingReply) {
        var eventType = 'icon';

        if (isPressedEnter) {
          eventType = 'keystroke';
        }

        ccxIngest.fireEvent({
          event: {
            subcategory: 'reply-comment',
            subtype: 'submit',
            type: eventType
          },
          content: {
            parent_id: id
          }
        });
        var mentionedUsers = [];
        var preppedReplyText = replyText;

        if (mentionsEnabled) {
          mentionedUsers = textareaInstance.getAcceptedMentions();
          preppedReplyText = (0, _utils.replaceNameWithID)(preppedReplyText, mentionedUsers);
        }

        postReply(assetData.id, preppedReplyText, id, mentionedUsers, cacheComments).then(function () {
          // TODO: This can probably be done in postReply action.
          //       Might make sense to turn cleanCurrentNodeFocusedInputInfo into an action.
          compactLayout && _this3.cleanCurrentNodeFocusedInputInfo();
        }).catch(function (_ref3) {
          var status = _ref3.status,
              message = _ref3.message;
          compactLayout && _this3.cleanCurrentNodeFocusedInputInfo();
          ccxIngest.fireEvent({
            event: {
              context_guid: commentData.id,
              subcategory: 'reply-comment',
              subtype: 'error',
              type: 'render',
              error_code: status,
              error_type: message,
              error_desc: 'reply-failed-to-post'
            }
          });

          if (imsData.token.includes('AnonBearer') && status === 401) {
            resetGuestUserSession();
            onLogin(false);
          }
        });
      }
    }
    /**
     * Make sure date is never greater than client's Date.now()
     * @param {String} modified - string formatted date
     * @return {String} a date that is <= Date.now()
     */

  }, {
    key: "_getSafeDate",
    value: function _getSafeDate(modified) {
      return new Date(modified) < Date.now() ? +new Date(modified) : +Date.now();
    }
    /**
     * Handle click event for reply text box and calls ingest to register event
     * @return {undefined}
     */

  }, {
    key: "handleReplyOnClick",
    value: function handleReplyOnClick() {
      var _this$props13 = this.props,
          ccxIngest = _this$props13.ccxIngest,
          commentData = _this$props13.commentData,
          compactLayout = _this$props13.compactLayout,
          saveFocusedInputInfo = _this$props13.saveFocusedInputInfo,
          assetData = _this$props13.assetData,
          focusedInputInfo = _this$props13.focusedInputInfo;
      var id = commentData.id;

      if (compactLayout) {
        if (!focusedInputInfo || !focusedInputInfo[assetData.nodeId] || focusedInputInfo[assetData.nodeId].id !== id) {
          saveFocusedInputInfo(_defineProperty({}, assetData.nodeId, {
            id: id,
            itemType: 'reply-input'
          }));
        }
      }

      ccxIngest.fireEvent({
        event: {
          subcategory: 'reply-comment',
          subtype: 'text-box',
          type: 'click'
        },
        content: {
          parent_id: id
        }
      });
    }
    /**
     * Handle blur event for replies
     * @return {undefined}
     */

  }, {
    key: "handleReplyOnBlur",
    value: function handleReplyOnBlur() {
      var _this$props14 = this.props,
          compactLayout = _this$props14.compactLayout,
          touchControls = _this$props14.touchControls;

      if (!compactLayout && !touchControls) {
        this._toggleReply();
      }
    }
    /**
     * function to toggle reply state
     * @return {undefined}
     */

  }, {
    key: "_toggleReply",
    value: function _toggleReply() {
      var _this$props15 = this.props,
          commentData = _this$props15.commentData,
          toggleReplyVisibility = _this$props15.toggleReplyVisibility,
          touchControls = _this$props15.touchControls;
      var replyTextareaInstance = this._replyTextareaEl;
      var draftReplyText = replyTextareaInstance.getTextareaInputValue(true);

      if (draftReplyText.length === 0 && commentData.replies.length === 0 && !this.isClickingReply) {
        toggleReplyVisibility(commentData.id);
      } else if (draftReplyText && draftReplyText.length > 0) {
        toggleReplyVisibility(commentData.id, draftReplyText);
      } else if (touchControls) {
        // Catch the touch controls Cancel button case
        toggleReplyVisibility(commentData.id);
      }
    }
    /**
     * Function to render the reply list
     * @returns {ReactElement} element for the reply list
     */

  }, {
    key: "_getReplyList",
    value: function _getReplyList() {
      var _this$props16 = this.props,
          assetData = _this$props16.assetData,
          commentData = _this$props16.commentData,
          compactLayout = _this$props16.compactLayout,
          focusedInputInfo = _this$props16.focusedInputInfo,
          imsData = _this$props16.imsData,
          mentionsEnabled = _this$props16.mentionsEnabled,
          onHeightChange = _this$props16.onHeightChange,
          touchControls = _this$props16.touchControls,
          intl = _this$props16.intl,
          isOffline = _this$props16.isOffline,
          richTextEntry = _this$props16.richTextEntry;
      var id = commentData.id,
          repliesOpen = commentData.repliesOpen,
          _commentData$replies = commentData.replies,
          replies = _commentData$replies === void 0 ? [] : _commentData$replies,
          creator = commentData.creator;
      var _this$state2 = this.state,
          dirtyReply = _this$state2.dirtyReply,
          overReplyTextLimit = _this$state2.overReplyTextLimit,
          replyTextPresent = _this$state2.replyTextPresent;
      var hasReplies = replies && replies.length >= 1;
      var replyInFocus = compactLayout && focusedInputInfo && focusedInputInfo[assetData.nodeId] ? focusedInputInfo[assetData.nodeId].itemType === 'reply-input' && focusedInputInfo[assetData.nodeId].id === id && !this.state.isEditing : false;
      var editInFocus = compactLayout && focusedInputInfo && focusedInputInfo[assetData.nodeId] ? focusedInputInfo[assetData.nodeId].itemType === 'edit' && focusedInputInfo[assetData.nodeId].id === id && this.state.isEditing : false;
      var editingReplyInFocus = compactLayout && focusedInputInfo && focusedInputInfo[assetData.nodeId] ? focusedInputInfo[assetData.nodeId].itemType === 'reply-item' && focusedInputInfo[assetData.nodeId].parentCommentId === id : false;
      var signedOut = !imsData || !imsData.token;
      var replyingToHeader = '';

      if (replyInFocus) {
        replyingToHeader = /*#__PURE__*/_react.default.createElement("div", {
          className: "replying-user-name"
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "comments.item.reply_to_user"
        }), "\xA0", creator.name);
      }

      var replyListContainer = ''; // eslint-disable-next-line no-unused-vars

      var _this$props17 = this.props,
          isSubmittingReply = _this$props17.isSubmittingReply,
          editingReplyId = _this$props17.editingReplyId,
          scrollIntoView = _this$props17.scrollIntoView,
          rest = _objectWithoutProperties(_this$props17, ["isSubmittingReply", "editingReplyId", "scrollIntoView"]);

      if (!replyInFocus && !editInFocus && replies.length > 0) {
        var replyList = replies.map(function (reply) {
          var userType = '';

          if (reply.creator.id === assetData.ownerId) {
            userType = intl.formatMessage({
              id: 'comments.item.owner'
            });
          }

          if (reply.creator.affiliation === 'https://comments.acrobat.com/auth_providers/guest') {
            userType = intl.formatMessage({
              id: 'comments.item.guest'
            });
          }

          var date = new Date(reply.modified).toLocaleDateString(intl.locale, DATE_FORMAT_OPTION);
          var commentSummary = intl.formatMessage({
            id: 'comments.arialabel.reply'
          }, {
            author: reply.creator.name,
            comment: reply.bodyValue,
            date: date,
            userType: userType
          });
          return /*#__PURE__*/_react.default.createElement("li", {
            "aria-label": commentSummary,
            role: "listitem",
            tabIndex: "0",
            key: "reply-".concat(reply.id)
          }, /*#__PURE__*/_react.default.createElement(Item, _extends({}, rest, {
            id: "reply-".concat(id),
            commentData: reply,
            itemType: "reply-item",
            parentCommentId: id,
            isResolved: commentData.status === 'resolved',
            isSaving: editingReplyId === reply.id,
            parentNodeId: (0, _lodash.default)(commentData, 'target.selector.node.id'),
            divider: false
          })));
        });
        replyListContainer = /*#__PURE__*/_react.default.createElement("ul", {
          className: "replies-list"
        }, replyList);
      }

      var replyBox;
      var replyIconsContainer;
      var replyButtonsContainer;
      var disableReplySubmission = overReplyTextLimit || !dirtyReply.trim().length || isSubmittingReply || isOffline;

      if (commentData.status !== 'resolved' && repliesOpen) {
        replyBox = /*#__PURE__*/_react.default.createElement("div", {
          className: "reply-box-wrap".concat(replies.length ? ' has-replies' : '')
        }, /*#__PURE__*/_react.default.createElement(_CommentInput.default, {
          animationEnabled: !compactLayout,
          compactLayout: compactLayout,
          initialValue: dirtyReply || '',
          mentionsEnabled: !isOffline && mentionsEnabled && !signedOut,
          onBlur: this.handleReplyOnBlur,
          onClick: this.handleReplyOnClick,
          onFocus: this.handleReplyFocus,
          onHeightChange: onHeightChange,
          onKeyUp: this.handleReplyOnKeyUp,
          onMentionClick: this.handleReplyMentionClick,
          onTextPresent: this.handleReplyTextPresent,
          placeholder: "comments.item.reply_placeholder",
          ref: this.handleReplyTextareaRef,
          richTextEntry: richTextEntry,
          shouldFocusIfValueExists: false,
          touchControls: touchControls
        }));
        replyIconsContainer = /*#__PURE__*/_react.default.createElement("div", {
          className: "submit-icon-container"
        }, /*#__PURE__*/_react.default.createElement(_Button.default, {
          disabled: disableReplySubmission,
          icon: /*#__PURE__*/_react.default.createElement(_Send.default, {
            size: "M"
          }),
          onClick: disableReplySubmission ? undefined : this.handleSubmitReply,
          selected: !disableReplySubmission,
          variant: "tool"
        }));
        replyButtonsContainer = /*#__PURE__*/_react.default.createElement("div", {
          className: "submit-button-container"
        }, /*#__PURE__*/_react.default.createElement(_Button.default, {
          disabled: !replyTextPresent || isSubmittingReply,
          id: "ccx-comments-reply-cancel-btn",
          quiet: true,
          onMouseDown: this.handleCancelReply,
          onClick: this.handleCancelReply
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "comments.submit.cancel"
        })), /*#__PURE__*/_react.default.createElement(_Button.default, {
          disabled: disableReplySubmission,
          id: "ccx-comments-reply-submit-btn",
          variant: "primary",
          quiet: true,
          onClick: this.handleSubmitReply,
          onMouseDown: function onMouseDown(evt) {
            return evt.preventDefault();
          }
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "comments.submit.submit"
        })));
      }

      var replyCompactLayoutContainer = /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('replies-wrapper', {
          'focused-input': replyInFocus,
          'has-replies': hasReplies
        })
      }, replyListContainer, replyingToHeader, /*#__PURE__*/_react.default.createElement("div", {
        className: "comment-text-controls-container icon-layout ".concat(replyInFocus ? ' focused-input' : '')
      }, (replyInFocus || repliesOpen) && !this.state.isEditing && !editingReplyInFocus ? replyBox : '', (replyInFocus || repliesOpen) && !this.state.isEditing && !editingReplyInFocus ? replyIconsContainer : ''));

      var replyDesktopContainer = /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)('replies-wrapper', {
          'has-replies': hasReplies
        })
      }, replyListContainer, /*#__PURE__*/_react.default.createElement("div", {
        className: "comment-text-controls-container"
      }, replyBox, replyButtonsContainer));

      return /*#__PURE__*/_react.default.createElement(_reactTransitionGroup.CSSTransition, {
        in: replies && repliesOpen,
        timeout: 500,
        classNames: "fade",
        unmountOnExit: true
      }, compactLayout ? replyCompactLayoutContainer : replyDesktopContainer);
    }
    /**
     * Sets the local state of the textarea content so we know when to
     * disable the submit button and stop enter key submit
     * @param {String} editText - the comment text
     * @param {Boolean} overTextLimit - if comment >= maxCharacters
     * @return {undefined}
     */

  }, {
    key: "handleEditTextPresent",
    value: function handleEditTextPresent(editText, overTextLimit) {
      var commentData = this.props.commentData;
      var editTextPresent = editText.length > 0;
      commentData.dirtyEdit = editText.trim();
      this.setState({
        editTextPresent: editTextPresent,
        overEditTextLimit: overTextLimit
      });
    }
    /**
     * Sets the local state of the textarea content so we know when to
     * disable the submit button and stop enter key submit
     * @param {String} replyText - the comment text
     * @param {Boolean} overTextLimit - if comment >= maxCharacters
     * @return {undefined}
     */

  }, {
    key: "handleReplyTextPresent",
    value: function handleReplyTextPresent(replyText, overTextLimit) {
      var replyTextPresent = replyText.length > 0;
      this.setState({
        dirtyReply: replyText,
        overReplyTextLimit: overTextLimit,
        replyTextPresent: replyTextPresent
      });
    }
    /**
     * Handles focus event.
     * @return {undefined}
     */

  }, {
    key: "handleFocus",
    value: function handleFocus() {
      var _this$props18 = this.props,
          commentData = _this$props18.commentData,
          parentCommentId = _this$props18.parentCommentId,
          saveFocusedInputInfo = _this$props18.saveFocusedInputInfo,
          compactLayout = _this$props18.compactLayout,
          itemType = _this$props18.itemType,
          assetData = _this$props18.assetData,
          focusedInputInfo = _this$props18.focusedInputInfo;

      if (compactLayout) {
        var objFocusedInputInfo = focusedInputInfo || {};
        objFocusedInputInfo[assetData.nodeId] = {
          id: commentData.id,
          parentCommentId: parentCommentId,
          itemType: itemType || 'edit'
        };
        saveFocusedInputInfo(objFocusedInputInfo);
      }
    }
    /**
     * Handles focus event on the reply text area.
     * @param {SyntheticEvent} evt - a wrapper around the browser's native event
     * @return {undefined}
     */

  }, {
    key: "handleReplyFocus",
    value: function handleReplyFocus(evt) {
      var _this$props19 = this.props,
          compactLayout = _this$props19.compactLayout,
          touchControls = _this$props19.touchControls;

      if (touchControls) {
        requestAnimationFrame(function () {
          var clientRect = evt.target.getBoundingClientRect();

          if (compactLayout) {
            window.scrollTo(0, clientRect.bottom);
          } else {
            window.scrollBy(0, clientRect.top - REPLY_INPUT_OFFSET_TOP);
          }
        });
      }
    }
    /**
     * Handler for clicking the edit button
     * @returns {undefined}
     */

  }, {
    key: "cancelEdit",
    value: function cancelEdit() {
      var commentData = this.props.commentData;
      this.setState(function () {
        return {
          isEditing: true
        };
      }, function () {
        commentData.dirtyEdit = (0, _lodash.default)(commentData, 'bodyValue');
      });
    }
    /**
     * Handler for clicking the edit button
     * @returns {undefined}
     */

  }, {
    key: "handleEditBtnClick",
    value: function handleEditBtnClick() {
      var _this$props20 = this.props,
          ccxIngest = _this$props20.ccxIngest,
          commentData = _this$props20.commentData,
          parentCommentId = _this$props20.parentCommentId;
      this.cancelEdit();
      ccxIngest.fireEvent({
        event: {
          context_guid: parentCommentId,
          subcategory: 'edit-comment',
          subtype: 'edit',
          type: 'click'
        },
        content: {
          parent_id: commentData.id
        }
      });
    }
    /**
     * Handler for clicking the cancel edit button
     * @returns {undefined}
     */

  }, {
    key: "handleCancelEditBtnClick",
    value: function handleCancelEditBtnClick() {
      var _this$props21 = this.props,
          ccxIngest = _this$props21.ccxIngest,
          commentData = _this$props21.commentData,
          parentCommentId = _this$props21.parentCommentId;
      this.setState({
        isEditing: false,
        overEditTextLimit: false
      }, function () {
        commentData.dirtyEdit = null;
      });
      this.cleanCurrentNodeFocusedInputInfo();
      ccxIngest.fireEvent({
        event: {
          context_guid: parentCommentId,
          subcategory: 'edit-comment',
          subtype: 'cancel',
          type: 'click'
        },
        content: {
          parent_id: commentData.id
        }
      });
    }
    /**
     * Handler for clicking the cancel reply button
     * @param {Event} evt - javascript event object
     * @returns {undefined}
     */

  }, {
    key: "handleCancelReply",
    value: function handleCancelReply(evt) {
      evt.preventDefault(); // Clear the text area

      var textareaInstance = this._replyTextareaEl;

      if (!textareaInstance) {
        return;
      }

      textareaInstance.clearTextareaInput();
      this.setState({
        dirtyReply: ''
      });
      (0, _utils.deleteFromSessionStorage)(_constants.REPLY_BEFORE_SIGNIN);
    }
    /**
     * Closes login window when a user logs in.
     * @returns {undefined}
     */

  }, {
    key: "handleGuestLogin",
    value: function handleGuestLogin() {
      this.setState({
        showLogin: false
      });
    }
    /**
     * Handle cancelling login flow
     * @return {undefined}
     */

  }, {
    key: "handleCancelLogin",
    value: function handleCancelLogin() {
      this.setState({
        showLogin: false
      });
      (0, _utils.deleteFromSessionStorage)(_constants.REPLY_BEFORE_SIGNIN);
    }
    /**
     * Handle clicking on the @ button for edit
     * @return {undefined}
     */

  }, {
    key: "handleEditMentionClick",
    value: function handleEditMentionClick() {
      var ccxIngest = this.props.ccxIngest;
      ccxIngest.fireEvent({
        event: {
          subcategory: 'edit-comment',
          type: 'click',
          subtype: 'mention'
        }
      });
    }
    /**
     * Handle clicking on the @ button for reply
     * @return {undefined}
     */

  }, {
    key: "handleReplyMentionClick",
    value: function handleReplyMentionClick() {
      var ccxIngest = this.props.ccxIngest;
      ccxIngest.fireEvent({
        event: {
          subcategory: 'reply-comment',
          type: 'click',
          subtype: 'mention'
        }
      });
    }
    /**
     * Common function to call edit data api between enter key and save change button click
     * @param {String} commentText - the comment text
     * @returns {undefined}
     */

  }, {
    key: "editData",
    value: function editData(commentText) {
      var _this4 = this;

      var _this$props22 = this.props,
          assetData = _this$props22.assetData,
          cacheComments = _this$props22.cacheComments,
          ccxIngest = _this$props22.ccxIngest,
          commentData = _this$props22.commentData,
          compactLayout = _this$props22.compactLayout,
          editComment = _this$props22.editComment,
          imageCapture = _this$props22.imageCapture,
          imsData = _this$props22.imsData,
          parentCommentId = _this$props22.parentCommentId,
          mentionsEnabled = _this$props22.mentionsEnabled,
          resetGuestUserSession = _this$props22.resetGuestUserSession;
      var onLogin = this.context.onLogin;
      var textareaInstance = this._editTextareaEl;
      var cmtTxt = commentText.trim();
      var mentionedUsers = [];

      if (mentionsEnabled && textareaInstance) {
        mentionedUsers = textareaInstance.getAcceptedMentions(cmtTxt);
        cmtTxt = (0, _utils.replaceNameWithID)(cmtTxt, mentionedUsers);
      }

      if (cmtTxt || commentData.hasStrikethroughAnnotation) {
        editComment(assetData.id, commentData, parentCommentId, cmtTxt, mentionedUsers, cacheComments, imageCapture).then(function () {
          compactLayout && _this4.cleanCurrentNodeFocusedInputInfo();
          var prevMentionedIds = commentData && commentData.mentions && commentData.mentions.map(function (mention) {
            return mention.id;
          }) || [];
          var hasNewMention = mentionedUsers.some(function (mention) {
            return !prevMentionedIds.includes(mention.id);
          });

          if (hasNewMention) {
            ccxIngest.fireEvent({
              event: {
                context_guid: parentCommentId,
                subcategory: 'edit-comment',
                subtype: 'mention',
                type: 'render'
              }
            });
          }

          ccxIngest.fireEvent({
            event: {
              context_guid: parentCommentId,
              subcategory: 'edit-comment',
              subtype: 'edit-comment',
              type: 'render'
            }
          });
        }).catch(function (_ref4) {
          var status = _ref4.status,
              message = _ref4.message;
          ccxIngest.fireEvent({
            event: {
              context_guid: parentCommentId,
              subcategory: 'edit-comment',
              subtype: 'error',
              type: 'render',
              error_code: status,
              error_type: message,
              error_desc: 'comment-failed-to-edit'
            }
          });

          if (imsData.token.includes('AnonBearer') && status === 401) {
            resetGuestUserSession();
            onLogin(false);

            _this4.cancelEdit();
          }
        });
      }
    }
    /**
     * Handler for clicking the Save Changes button when user is editing comment
     * @returns {undefined}
     */

  }, {
    key: "handleSaveEditChangesBtnClick",
    value: function handleSaveEditChangesBtnClick() {
      var textareaInstance = this._editTextareaEl;
      var commentText = textareaInstance && textareaInstance.getTextareaInputValue(true);

      if (!this.state.overEditTextLimit) {
        this.editData(commentText);
        var _this$props23 = this.props,
            ccxIngest = _this$props23.ccxIngest,
            commentData = _this$props23.commentData,
            parentCommentId = _this$props23.parentCommentId;
        ccxIngest.fireEvent({
          event: {
            context_guid: parentCommentId,
            subcategory: 'edit-comment',
            subtype: 'submit',
            type: 'click'
          },
          content: {
            parent_id: commentData.id
          }
        });
      }
    }
    /**
     * Handler for key up event for edit text box
     * @param {Event} evt - javascript event object
     * @returns {undefined}
     */

  }, {
    key: "handleEditOnKeyUp",
    value: function handleEditOnKeyUp(evt) {
      var _this$props24 = this.props,
          commentData = _this$props24.commentData,
          isOffline = _this$props24.isOffline;
      var overEditTextLimit = this.state.overEditTextLimit;
      var editText = commentData.dirtyEdit;

      if ((0, _utils.isKeyboardSubmit)(evt) && (editText || commentData.hasStrikethroughAnnotation) && !overEditTextLimit && !this.state.editSaving && !isOffline) {
        this.editData(editText);
        var _this$props25 = this.props,
            ccxIngest = _this$props25.ccxIngest,
            parentCommentId = _this$props25.parentCommentId;
        ccxIngest.fireEvent({
          event: {
            context_guid: parentCommentId,
            subcategory: 'edit-comment',
            subtype: 'submit',
            type: 'keystroke'
          },
          content: {
            parent_id: commentData.id
          }
        });
      }
    }
    /**
     * private function to clean current node focused input box information from redux
     * @return {undefined}
     */

  }, {
    key: "cleanCurrentNodeFocusedInputInfo",
    value: function cleanCurrentNodeFocusedInputInfo() {
      var _this$props26 = this.props,
          assetData = _this$props26.assetData,
          compactLayout = _this$props26.compactLayout,
          saveFocusedInputInfo = _this$props26.saveFocusedInputInfo,
          focusedInputInfo = _this$props26.focusedInputInfo;

      if (compactLayout) {
        var tempFocusedInputInfo = focusedInputInfo;
        delete tempFocusedInputInfo[assetData.nodeId];

        if (Object.keys(tempFocusedInputInfo).length > 0) {
          saveFocusedInputInfo(tempFocusedInputInfo);
        } else {
          saveFocusedInputInfo();
        }
      }
    }
    /**
     * Create reference to the edit textarea input
     * @param {ReactElement} ref - react element to create a reference to
     * @return {undefined}
     */

  }, {
    key: "handleEditTextareaRef",
    value: function handleEditTextareaRef(ref) {
      this._editTextareaEl = ref;
    }
    /**
     * Handler for on click event for edit text box
     * @returns {undefined}
     */

  }, {
    key: "handleEditOnClick",
    value: function handleEditOnClick() {
      var _this$props27 = this.props,
          ccxIngest = _this$props27.ccxIngest,
          commentData = _this$props27.commentData,
          parentCommentId = _this$props27.parentCommentId,
          saveFocusedInputInfo = _this$props27.saveFocusedInputInfo,
          compactLayout = _this$props27.compactLayout,
          itemType = _this$props27.itemType,
          assetData = _this$props27.assetData,
          focusedInputInfo = _this$props27.focusedInputInfo;
      var id = commentData.id;

      if (compactLayout) {
        var objFocusedInputInfo = focusedInputInfo || {};
        objFocusedInputInfo[assetData.nodeId] = {
          id: id,
          parentCommentId: parentCommentId,
          itemType: itemType || 'edit'
        };
        saveFocusedInputInfo(objFocusedInputInfo);
      }

      ccxIngest.fireEvent({
        event: {
          context_guid: parentCommentId,
          subcategory: 'edit-comment',
          subtype: 'text-box',
          type: 'click'
        },
        content: {
          parent_id: id
        }
      });
    }
    /**
     * Handle click on the place pin button
     * @return {undefined}
     */

  }, {
    key: "handlePinClick",
    value: function handlePinClick() {
      var _this$props28 = this.props,
          ccxIngest = _this$props28.ccxIngest,
          commentData = _this$props28.commentData,
          compactLayout = _this$props28.compactLayout,
          isAnnotating = _this$props28.isAnnotating,
          toggleAnnotating = _this$props28.toggleAnnotating;
      var id = commentData.id;

      if (isAnnotating) {
        ccxIngest.fireEvent({
          event: {
            subcategory: 'pin-comment',
            type: 'click',
            subtype: this.isAnnotated() ? 'edit-pin' : 'add-pin'
          }
        });
      }

      toggleAnnotating(id, 'pin', compactLayout);
    }
    /**
     * Handle mouseover/mouseleave on the comment item
     * @param {Event} evt - javascript event object
     * @return {undefined}
     */

  }, {
    key: "handleItemHover",
    value: function handleItemHover(evt) {
      var _this$props29 = this.props,
          assetData = _this$props29.assetData,
          commentData = _this$props29.commentData,
          setHoveredAnnotation = _this$props29.setHoveredAnnotation,
          globalCommentsToggle = _this$props29.globalCommentsToggle;
      var _this$context$onComme = this.context.onCommentHover,
          onCommentHover = _this$context$onComme === void 0 ? function () {} : _this$context$onComme;
      var hasAnnotation = this.isAnnotated();
      var isHovered = evt.type === 'mouseenter';
      var nodeId = (0, _lodash.default)(commentData, 'target.selector.node.id');
      var activeComment = nodeId === assetData.nodeId;
      var isGlobalCommentsToggleActive = globalCommentsToggle.isActive;

      if (hasAnnotation && setHoveredAnnotation) {
        setHoveredAnnotation(isHovered ? commentData.id : undefined);
      }

      if (!isGlobalCommentsToggleActive || isGlobalCommentsToggleActive && activeComment) {
        onCommentHover(evt, commentData, isHovered, hasAnnotation);
      }
    }
    /**
     * Handle click on the comment item
     * @param {Event} evt - JavaScript click event object
     * @return {undefined}
     */

  }, {
    key: "handleItemClick",
    value: function handleItemClick(evt) {
      var _this$props30 = this.props,
          assetData = _this$props30.assetData,
          commentData = _this$props30.commentData,
          compactLayout = _this$props30.compactLayout,
          setHoveredAnnotation = _this$props30.setHoveredAnnotation,
          globalCommentsToggle = _this$props30.globalCommentsToggle;
      var _this$context$onComme2 = this.context.onCommentClick,
          onCommentClick = _this$context$onComme2 === void 0 ? function () {} : _this$context$onComme2;
      var hasAnnotation = this.isAnnotated();
      var nodeId = (0, _lodash.default)(commentData, 'target.selector.node.id');
      var activeComment = nodeId === assetData.nodeId;
      var isGlobalCommentsToggleActive = globalCommentsToggle.isActive;

      if (!isGlobalCommentsToggleActive || isGlobalCommentsToggleActive && activeComment) {
        onCommentClick(evt, commentData, hasAnnotation);
      }

      if (compactLayout && setHoveredAnnotation) {
        setHoveredAnnotation(hasAnnotation ? commentData.id : undefined);
      }
    }
    /**
     * Parse the comment text, creating mention user cards
     * @param {string} comment - comment text
     * @param {Array} mentions - array of mention objects
     * @return {Array} an array of
     */

  }, {
    key: "_parseMentions",
    value: function _parseMentions(comment) {
      var _this5 = this;

      var mentions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var touchControls = this.props.touchControls;
      var commentArray = [comment];
      var removedMatchedNames = [];
      var overlayTrigger = touchControls ? 'click' : 'hover';
      mentions.forEach(function (user) {
        // Determine unique mention instances and generate User Card Popovers for each mention
        for (var commentArrayIndex = 0; commentArrayIndex < commentArray.length; commentArrayIndex++) {
          if (typeof commentArray[commentArrayIndex] === 'string') {
            // Check string fragment for names (legacy)
            removedMatchedNames = commentArray[commentArrayIndex].split("@".concat(user.name)); // Somewhere between Courier and Comments Service the spaces are being stripped from the names
            // This should be a temorary fix until Comments Service or Courier fixes the issue.
            // The returned message should either be `[@urn:userID:123@AdobeID]` or `@Bill Smith`.
            // Right now they are incorrectly returning `@BillSmith`

            if (removedMatchedNames.length === 1) {
              removedMatchedNames = commentArray[commentArrayIndex].split("@".concat(user.name.replace(/ /g, '')));
            } // If no names found check for Adobe ID
            // This may no longer be needed. Waiting on final solution from Comments Service.


            if (removedMatchedNames.length === 1) {
              removedMatchedNames = commentArray[commentArrayIndex].split("[@urn:userID:".concat(user.id, "]"));
            }

            if (removedMatchedNames.length > 1) {
              var matchedUserObj = mentions.find(function (curUser) {
                return curUser.id === "".concat(_constants.USER_ID_PREFIX).concat(user.id);
              }) || user;
              commentArray.splice.apply(commentArray, [commentArrayIndex, 1].concat(_toConsumableArray(_this5._commentPopoverBuilder(removedMatchedNames, /*#__PURE__*/_react.default.createElement(_OverlayTrigger.default, {
                key: matchedUserObj.email,
                placement: "top",
                trigger: overlayTrigger
              }, /*#__PURE__*/_react.default.createElement("span", {
                className: "mention"
              }, "@".concat(matchedUserObj.name)), /*#__PURE__*/_react.default.createElement(_UserCard.UserCardPopover, null, /*#__PURE__*/_react.default.createElement(_UserCard.default, {
                user: matchedUserObj
              })))))));
            }
          }
        }
      });
      return commentArray;
    }
    /**
     * Helper function for _parseMentions
     * @param {Array} matches - array of text split on the matched user name
     * @param {Object} jsx - a jsx object of what to include between text
     * @return {Array} - Mix of strings and jsx. ["hello", <popover>@Billy</popover>, "how are you today?"]
     */

  }, {
    key: "_commentPopoverBuilder",
    value: function _commentPopoverBuilder(matches, jsx) {
      var commentsConstructor = [];

      while (matches.length > 1) {
        commentsConstructor.push(matches.shift());
        commentsConstructor.push(jsx);
      }

      commentsConstructor.push(matches.shift()); // add last text fragment

      return commentsConstructor;
    }
    /**
     * Lifecycle method for rendering
     * @returns {ReactElement} markup
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props31 = this.props,
          annotationTypes = _this$props31.annotationTypes,
          annotationsMultiPageEnabled = _this$props31.annotationsMultiPageEnabled,
          assetData = _this$props31.assetData,
          commentData = _this$props31.commentData,
          compactLayout = _this$props31.compactLayout,
          divider = _this$props31.divider,
          focusedInputInfo = _this$props31.focusedInputInfo,
          highlight = _this$props31.highlight,
          isOffline = _this$props31.isOffline,
          isSaving = _this$props31.isSaving,
          itemType = _this$props31.itemType,
          mentionsEnabled = _this$props31.mentionsEnabled,
          onHeightChange = _this$props31.onHeightChange,
          parentCommentId = _this$props31.parentCommentId,
          parentNodeId = _this$props31.parentNodeId,
          richTextEntry = _this$props31.richTextEntry,
          showCommentId = _this$props31.showCommentId,
          spectrumUIScale = _this$props31.spectrumUIScale,
          reCaptchaEnabled = _this$props31.reCaptchaEnabled,
          theme = _this$props31.theme,
          touchControls = _this$props31.touchControls,
          viewingUnmapped = _this$props31.viewingUnmapped;
      var _commentData$bodyValu = commentData.bodyValue,
          bodyValue = _commentData$bodyValu === void 0 ? '' : _commentData$bodyValu,
          creator = commentData.creator,
          dirtyEdit = commentData.dirtyEdit,
          hasHighlightAnnotation = commentData.hasHighlightAnnotation,
          hasInsertAnnotation = commentData.hasInsertAnnotation,
          hasReplaceAnnotation = commentData.hasReplaceAnnotation,
          hasShapeAnnotation = commentData.hasShapeAnnotation,
          hasStrikethroughAnnotation = commentData.hasStrikethroughAnnotation,
          id = commentData.id,
          imageContextData = commentData.imageContextData,
          mentions = commentData.mentions,
          pinNum = commentData.pinNum,
          replies = commentData.replies,
          repliesOpen = commentData.repliesOpen;

      if (compactLayout && focusedInputInfo && focusedInputInfo[assetData.nodeId] && !this.isInputFocused()) {
        if (focusedInputInfo[assetData.nodeId].id !== id) {
          return null;
        }
      }

      var _this$state3 = this.state,
          overEditTextLimit = _this$state3.overEditTextLimit,
          isEditing = _this$state3.isEditing,
          showLogin = _this$state3.showLogin;
      var isReplyItemInFocus;

      if (focusedInputInfo && focusedInputInfo[assetData.nodeId] && itemType) {
        isReplyItemInFocus = compactLayout && focusedInputInfo[assetData.nodeId].itemType === 'reply-item' && itemType === 'reply-item' && focusedInputInfo[assetData.nodeId].id === id;

        if (!isReplyItemInFocus) {
          return null;
        }
      }

      var sanitizedBodyValue = bodyValue;

      if (mentions && mentions.length > 0) {
        sanitizedBodyValue = (0, _utils.replaceIDWithName)(bodyValue, mentions);
      }

      var nodeId = (0, _lodash.default)(commentData, 'target.selector.node.id');
      var showActive = parentCommentId ? parentNodeId !== undefined : !viewingUnmapped && nodeId === assetData.nodeId || commentData.unmapped && viewingUnmapped;
      var isEditMode = isEditing && showActive;
      var commentContent;
      var editContent;
      var actionableTypeComment = !parentCommentId && (hasInsertAnnotation || hasReplaceAnnotation); // top level comment with an insert or replace annotation

      if (isEditMode) {
        var editTextboxWrapper = /*#__PURE__*/_react.default.createElement("div", {
          className: "edit-wrapper"
        }, /*#__PURE__*/_react.default.createElement(_CommentInput.default, {
          allowCollapseOverride: hasStrikethroughAnnotation,
          animationEnabled: !compactLayout,
          compactLayout: compactLayout,
          defaultMentions: mentions,
          errorMsgKey: "comments.item.edit_error",
          initialValue: (0, _utils.replaceIDWithName)(dirtyEdit || sanitizedBodyValue.substr(0, _constants.COMMENT_TEXT_LIMIT), mentions),
          isOffline: isOffline,
          mentionsEnabled: !actionableTypeComment && !isOffline && mentionsEnabled,
          mobileCommentingMode: Boolean(focusedInputInfo && focusedInputInfo[assetData.nodeId]),
          onClick: this.handleEditOnClick,
          onFocus: this.handleFocus,
          onHeightChange: onHeightChange,
          onKeyUp: this.handleEditOnKeyUp,
          onMentionClick: this.handleEditMentionClick,
          onTextPresent: this.handleEditTextPresent,
          placeholder: "comments.item.edit_placeholder",
          ref: this.handleEditTextareaRef,
          richTextEntry: richTextEntry,
          touchControls: touchControls
        }));

        var disableSavingEditChanges = overEditTextLimit || commentData.dirtyEdit === sanitizedBodyValue || isSaving || isOffline || (!this.state.editTextPresent || !(commentData.dirtyEdit || '').trim().length) && !hasStrikethroughAnnotation;

        var editButtonsContainer = /*#__PURE__*/_react.default.createElement("div", {
          className: "footer is-editing"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "button-wrapper"
        }, /*#__PURE__*/_react.default.createElement(_Button.default, {
          className: "cancel-edited-changes-btn",
          disabled: isSaving,
          onClick: this.handleCancelEditBtnClick,
          onMouseDown: this.handleCancelEditBtnClick,
          quiet: true,
          variant: "secondary"
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "comments.item.cancel"
        })), /*#__PURE__*/_react.default.createElement(_Button.default, {
          className: "save-edited-changes-btn",
          disabled: disableSavingEditChanges,
          onClick: this.handleSaveEditChangesBtnClick,
          onMouseDown: this.handleSaveEditChangesBtnClick,
          variant: "primary",
          quiet: true
        }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
          id: "comments.item.save_changes"
        }))));

        var editIconsContainer = /*#__PURE__*/_react.default.createElement("div", {
          className: "submit-icon-container"
        }, /*#__PURE__*/_react.default.createElement(_Button.default, {
          disabled: disableSavingEditChanges,
          icon: /*#__PURE__*/_react.default.createElement(_Send.default, {
            size: "M"
          }),
          onClick: disableSavingEditChanges ? undefined : this.handleSaveEditChangesBtnClick,
          selected: !disableSavingEditChanges,
          variant: "tool"
        }));

        editContent = /*#__PURE__*/_react.default.createElement("div", {
          className: "comment-text-controls-container ".concat(compactLayout ? ' icon-layout' : '').concat(isReplyItemInFocus || focusedInputInfo && focusedInputInfo[assetData.nodeId] && focusedInputInfo[assetData.nodeId].itemType === 'edit' && focusedInputInfo[assetData.nodeId].id === id ? ' focused-input' : '')
        }, editTextboxWrapper, compactLayout ? editIconsContainer : editButtonsContainer);
      } else {
        // Render comment body - no edit
        var commentText;

        if (hasStrikethroughAnnotation && !sanitizedBodyValue) {
          commentText = /*#__PURE__*/_react.default.createElement("span", {
            className: "empty-strikethrough"
          }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
            id: "comments.item.empty_strikethrough"
          }));
        } else {
          commentText = this._parseMentions(sanitizedBodyValue.substr(0, _constants.COMMENT_TEXT_LIMIT), mentions);
        }

        if (hasInsertAnnotation && !parentCommentId) {
          commentText = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
            id: "comments.item.insert_label"
          }, function (txt) {
            return /*#__PURE__*/_react.default.createElement("span", {
              className: "comment-text-label"
            }, txt);
          }), ' ', commentText);
        } else if (hasReplaceAnnotation && !parentCommentId) {
          commentText = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
            id: "comments.item.replace_label"
          }, function (txt) {
            return /*#__PURE__*/_react.default.createElement("span", {
              className: "comment-text-label"
            }, txt);
          }), ' ', commentText);
        }

        commentContent = /*#__PURE__*/_react.default.createElement("div", {
          className: "comment-text-controls-container"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "comment-text"
        }, /*#__PURE__*/_react.default.createElement(_reactLinkify.default, {
          component: _Link.default,
          properties: {
            target: '_blank',
            rel: 'noopener noreferrer'
          }
        }, /*#__PURE__*/_react.default.createElement("div", null, commentText))), imageContextData !== null && imageContextData !== void 0 && imageContextData.base64Data ? /*#__PURE__*/_react.default.createElement("img", {
          height: imageContextData.height,
          src: imageContextData.base64Data,
          width: imageContextData.width
        }) : null, this._getFooter(showActive));
      }

      var replyIds = replies && replies.length > 0 ? replies.map(function (reply) {
        return reply.id;
      }).join(' ') : undefined;
      var commentWrapperClasses = (0, _classnames.default)('comment-wrapper', {
        'focused-input': compactLayout && focusedInputInfo && focusedInputInfo[assetData.nodeId]
      });

      var commentContainer = /*#__PURE__*/_react.default.createElement("div", {
        id: id,
        role: "comment",
        "aria-owns": replyIds,
        className: commentWrapperClasses
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "comment-content-wrapper"
      }, isEditMode && compactLayout ? null : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "avatar-column"
      }, /*#__PURE__*/_react.default.createElement(_UserAvatar.default, {
        user: creator,
        className: "item-user-avatar"
      }), /*#__PURE__*/_react.default.createElement(_AnnotationMarker.default, {
        pinNum: pinNum,
        hasShapeAnnotation: hasShapeAnnotation,
        hasHighlightAnnotation: hasHighlightAnnotation,
        hasInsertAnnotation: hasInsertAnnotation,
        hasReplaceAnnotation: hasReplaceAnnotation,
        hasStrikethroughAnnotation: hasStrikethroughAnnotation,
        strokeColor: (0, _lodash.default)(commentData, 'target.selector.strokeColor'),
        visible: !parentCommentId && (showActive || annotationsMultiPageEnabled),
        annotationTypes: annotationTypes
      })), this._getHeader(showActive))), /*#__PURE__*/_react.default.createElement("div", {
        className: "row"
      }, commentContent)), editContent);

      var replyInFocus = compactLayout && focusedInputInfo && focusedInputInfo[assetData.nodeId] && focusedInputInfo[assetData.nodeId].itemType === 'reply-input' && focusedInputInfo[assetData.nodeId].id === id && !this.state.isEditing;
      var editingReplyInFocus = compactLayout && focusedInputInfo && focusedInputInfo[assetData.nodeId] && focusedInputInfo[assetData.nodeId].itemType === 'reply-item' && focusedInputInfo[assetData.nodeId].parentCommentId === id;
      var commentClassNames = (0, _classnames.default)('comment-li-wrapper', _Item.default.component, {
        highlight: (highlight && !parentCommentId || showCommentId === id) && !compactLayout,
        'hovered-pin': highlight,
        'replies-open': repliesOpen && showActive
      });
      var hasHoverEvents = !compactLayout && !parentCommentId;
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        "data-testid": "comment-li-wrapper",
        className: commentClassNames,
        ref: this.handleCommentItemRef,
        onMouseEnter: hasHoverEvents ? this.handleItemHover : null,
        onMouseLeave: hasHoverEvents ? this.handleItemHover : null,
        onClick: this.handleItemClick
      }, !replyInFocus && !editingReplyInFocus ? commentContainer : '', showActive ? this._getReplyList() : '', /*#__PURE__*/_react.default.createElement(_Login.default, {
        onGuestLogin: this.handleGuestLogin,
        onLoginCancel: this.handleCancelLogin,
        show: showLogin,
        spectrumUIScale: spectrumUIScale,
        theme: theme,
        reCaptchaEnabled: reCaptchaEnabled,
        reCaptchaSiteKey: this.props.reCaptchaSiteKey
      })), divider && /*#__PURE__*/_react.default.createElement(_Divider.default, null));
    }
  }]);

  return Item;
}(_react.default.Component);

exports.PureItem = Item;

_defineProperty(Item, "contextType", _CallbackContext.default);

Item.defaultProps = {
  annotationsEnabled: false,
  cacheComments: false,
  capabilities: {},
  ccxIngest: {
    fireEvent: function fireEvent() {}
  },
  compactLayout: false,
  confirmDelete: function confirmDelete() {},
  divider: false,
  editComment: function editComment() {},
  isOffline: false,
  onScrollToComment: function onScrollToComment() {},
  postReply: function postReply() {},
  reCaptchaSiteKey: '',
  resolveComment: function resolveComment() {},
  saveFocusedInputInfo: function saveFocusedInputInfo() {},
  setClickedAnnotationCommentId: function setClickedAnnotationCommentId() {},
  spectrumUIScale: 'medium',
  theme: 'light',
  toggleAnnotating: function toggleAnnotating() {},
  toggleReplyVisibility: function toggleReplyVisibility() {},
  unresolveComment: function unresolveComment() {}
};
Item.propTypes = {
  annotatingCommentId: _propTypes.default.string,
  annotationTypes: _propTypes.default.shape({
    draw: _propTypes.default.bool,
    pin: _propTypes.default.bool,
    text: _propTypes.default.bool
  }),
  annotationsEnabled: _propTypes.default.bool,
  annotationsCreationEnabled: _propTypes.default.bool,
  annotationsMultiPageEnabled: _propTypes.default.bool,
  assetData: _propTypes.default.shape({
    id: _propTypes.default.string,
    nodeId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    ownerId: _propTypes.default.string,
    region: _propTypes.default.string
  }),
  cacheComments: _propTypes.default.bool,
  capabilities: _propTypes.default.shape({
    role: _propTypes.default.string
  }),
  ccxIngest: _propTypes.default.object,
  commentData: _propTypes.default.object,
  closeButtonClicked: _propTypes.default.bool,
  compactLayout: _propTypes.default.bool,
  confirmDelete: _propTypes.default.func,
  setShowCommentId: _propTypes.default.func,
  divider: _propTypes.default.bool,
  editComment: _propTypes.default.func,
  editingReplyId: _propTypes.default.string,
  focusedInputInfo: _propTypes.default.object,
  globalCommentsToggle: _propTypes.default.shape({
    isActive: _propTypes.default.bool.isRequired
  }).isRequired,
  highlight: _propTypes.default.bool,
  imageCapture: _propTypes.default.bool,
  imageContextData: _propTypes.default.object,
  imsData: _propTypes.default.shape({
    id: _propTypes.default.string,
    token: _propTypes.default.string
  }),
  intl: _propTypes.default.object.isRequired,
  isAnnotating: _propTypes.default.bool,
  isOffline: _propTypes.default.bool,
  isResolved: _propTypes.default.bool,
  isSaving: _propTypes.default.bool,
  isSubmittingReply: _propTypes.default.bool,
  itemType: _propTypes.default.string,
  mentionsEnabled: _propTypes.default.bool,
  onScrollToComment: _propTypes.default.func,
  onHeightChange: _propTypes.default.func,
  parentCommentId: _propTypes.default.string,
  parentNodeId: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  postReply: _propTypes.default.func,
  reCaptchaEnabled: _propTypes.default.bool.isRequired,
  reCaptchaSiteKey: _propTypes.default.string,
  resetGuestUserSession: _propTypes.default.func,
  resolveComment: _propTypes.default.func,
  richTextEntry: _propTypes.default.bool,
  saveFocusedInputInfo: _propTypes.default.func,
  scrollIntoView: _propTypes.default.bool,
  setClickedAnnotationCommentId: _propTypes.default.func,
  setHoveredAnnotation: _propTypes.default.func,
  setUnmappedView: _propTypes.default.func,
  showCommentId: _propTypes.default.string,
  spectrumUIScale: _propTypes.default.oneOf(['medium', 'large']),
  theme: _propTypes.default.oneOf(['light', 'lightest', 'dark', 'darkest']),
  toggleAnnotating: _propTypes.default.func,
  toggleReplyVisibility: _propTypes.default.func,
  touchControls: _propTypes.default.bool,
  unresolveComment: _propTypes.default.func,
  viewingUnmapped: _propTypes.default.bool
};

var mapStateToProps = function mapStateToProps(state, ownProps) {
  var _imsData$token;

  var annotationsEnabled = ownProps.annotationsEnabled,
      commentData = ownProps.commentData,
      compactLayout = ownProps.compactLayout,
      mentionsEnabled = ownProps.mentionsEnabled,
      imsData = ownProps.imsData;
  var annotatingCommentId = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.annotatingItmId"));
  var clickedAnnotationCommentId = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.clickedAnnotation"));
  var editingCommentId = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.editingCommentId"));
  var editingReplyId = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.editingReplyId"));
  var editingReplyParentCommentId = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.editingReplyParentCommentId"));
  var focusedInputInfo = compactLayout ? (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.focusedInputInfo")) : undefined;
  var hoveredAnnotationCommentId = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":annotation.hoveredAnnotation"));
  var submittingReplyParentCommentId = (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":comments.postingReplyParentCommentId"));
  return {
    annotationsEnabled: annotationsEnabled,
    commentsListMinimized: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.commentsListMinimized")),
    editingReplyId: editingReplyParentCommentId === commentData.id ? editingReplyId : undefined,
    focusedInputInfo: focusedInputInfo,
    highlight: hoveredAnnotationCommentId === commentData.id,
    isAnnotating: annotatingCommentId === commentData.id,
    isSaving: editingCommentId === commentData.id,
    isSubmittingReply: submittingReplyParentCommentId === commentData.id,
    mentionsEnabled: mentionsEnabled && (imsData === null || imsData === void 0 ? void 0 : (_imsData$token = imsData.token) === null || _imsData$token === void 0 ? void 0 : _imsData$token.indexOf('AnonBearer')) === -1,
    scrollIntoView: clickedAnnotationCommentId === commentData.id,
    showCommentId: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.showCommentId")),
    viewingUnmapped: (0, _lodash.default)(state, "".concat(_constants.PREFIX, ":context.viewingUnmapped"))
  };
};

var mapDispatchToProps = {
  editComment: _comments.commentsEdit,
  confirmDelete: _comments.commentDeletePropose,
  postReply: _comments.postReply,
  resolveComment: _comments.commentsResolve,
  saveFocusedInputInfo: _context.contextSaveFocusedInputInfo,
  setClickedAnnotationCommentId: _context.contextSetClickedAnnotation,
  setHoveredAnnotation: _annotation.annotationSetHoveredAnnotation,
  setShowCommentId: _context.contextSetShowCommentId,
  toggleAnnotating: _context.toggleAnnotationMode,
  toggleReplyVisibility: _comments.commentsToggleReply,
  unresolveComment: _comments.commentsOpen,
  resetGuestUserSession: _context.contextResetGuestUserSession
};
var enhance = (0, _redux.compose)(_AppContext.withAppContext, (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps, undefined, {
  context: _reducers.reduxContext
}));

var _default = enhance((0, _reactIntl.injectIntl)(Item, {
  forwardRef: true
}));

exports.default = _default;